"use client";
import React from "react";
import "./Why_Choose.css";

const Why_Choose = () => {
  return (
    <section className="why_choose_section">
      <div className="container">
        <div className="majestry_container">
          <div className="majestry_content">
            <h2 className="majestry_title">Why SeedSo?</h2>
            <p className="majestry_text">
              At SeedSo, we believe every successful harvest begins with the
              right seed. Our premium-quality seeds are developed to deliver
              excellent germination, vigorous plant growth, and consistent
              performance. With a commitment to innovation and sustainable
              agriculture, we help farmers achieve healthier crops and greater
              productivity.
            </p>
          </div>

          <div className="majestry_image_wrapper">
            <img
              src="/assets/images/home/why-nutricos/img01.png"
              alt="Majesty Mattress Production"
              className="majestry_image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose;
